interface IProps {
  href: string;
  src: string;
  alt?: string;
}

export const LogoLink = ({ href, src, alt }: IProps) => {
  return (
    <a href={href}>
      <img src={src} alt={alt || "logo"} loading={"lazy"} />
    </a>
  );
};
